export default {
  me: null, //내 정보,
  accessToken: "",
  adminAccessToken: "",
  kakaoAccount: null,
  certifyCard: "", // 인증받은 카드
};
